import { useEffect } from "react";
import { useTcmContent } from "./useTcmContent";
import TemplateShell from "../TemplateShell";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import TCMIntro from "./components/TCMIntro";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import FAQ from "./components/FAQ";
import HealthBlog from "./components/HealthBlog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppSticky from "./components/WhatsAppSticky";

export default function TcmPreview() {
  const { loading } = useTcmContent();

  // 載入 tcm-v1 使用的 Google Fonts（Noto Serif TC / Noto Sans TC）
  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@400;600;700&family=Noto+Sans+TC:wght@400;500;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    document.title = "明德中醫診所 - 模板預覽";
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-rice-50">
        <div className="text-pine-800">載入中...</div>
      </div>
    );
  }

  // error 時 hook 已 fallback 至預設內容，直接渲染即可
  return (
    <TemplateShell templateName="明德中醫診所" templateSlug="tcm-v1">
      <div className="min-h-screen">
        <Navigation />
        <main>
          <Hero />
          <About />
          <TCMIntro />
          <Services />
          <Gallery />
          <FAQ />
          <HealthBlog />
          <Contact />
        </main>
        <Footer />
        <WhatsAppSticky />
      </div>
    </TemplateShell>
  );
}
